import { Band, CycleStatus, IReviewSummary, ReviewStatus } from '../../interfaces/appraisal.interface';

export type ChipColor = 'default' | 'primary' | 'info' | 'success' | 'warning' | 'error';

/** Band → chip colour. The labels live in the `appraisal` namespace under `band.<BAND>`. */
export const bandColor: Record<Band, ChipColor> = {
    UNSATISFACTORY: 'error',
    NEEDS_IMPROVEMENT: 'warning',
    MEETS: 'info',
    EXCEEDS: 'primary',
    OUTSTANDING: 'success',
};

export const reviewStatusColor: Record<ReviewStatus, ChipColor> = {
    PENDING: 'default',
    SELF_SUBMITTED: 'info',
    MANAGER_SUBMITTED: 'primary',
    ACKNOWLEDGED: 'success',
};

export const cycleStatusColor: Record<CycleStatus, ChipColor> = {
    DRAFT: 'default',
    ACTIVE: 'success',
    CLOSED: 'info',
};

/** The band a 1–5 rating falls in; used to label the points of the rating scale. */
export const bandForScore = (score: number): Band => {
    if (score < 1.5) return 'UNSATISFACTORY';
    if (score < 2.5) return 'NEEDS_IMPROVEMENT';
    if (score < 3.5) return 'MEETS';
    if (score < 4.5) return 'EXCEEDS';
    return 'OUTSTANDING';
};

export const formatScore = (score?: number | null): string =>
    score === null || score === undefined ? '—' : score.toFixed(2);

export const isManagerDone = (status: ReviewStatus) => status === 'MANAGER_SUBMITTED' || status === 'ACKNOWLEDGED';

/** A review left unfinished when its cycle closed. */
export const isNotCompleted = (review: Pick<IReviewSummary, 'status' | 'cycleStatus'>) =>
    review.cycleStatus === 'CLOSED' && !isManagerDone(review.status);
